import React, {useState, useEffect} from 'react';
import Dialog from '@material-ui/core/Dialog';
import Lancamentos from '../App/Dre/Lancamentos';
import {Header, Content} from '../App/Dre/Dre2';
// import useFetchData from '../../crud/useFetchData';
// import {proto,url} from '../../Helpers/api';
// import {get,sortBy} from 'lodash-es';
// import {formataMoeda} from '../../Helpers/money';
// import styled, {css} from 'styled-components';
// import Typography from '@material-ui/core/Typography';
// import Seletor from '../Seletor';
// import {mesesExtenso} from '../../Helpers/date';
// import {
//   FormControl,
//   // FormControlLabel,
//   InputLabel,
//   Select,
//   Button,
//   // Switch,
//   MenuItem,
//   Card,
// } from '@material-ui/core';
// import Grafico1 from './Grafico1';
// import cores, {getColor} from '../../Common/Cores'


export default function Page_Dre2 (props) {
  const { empresas } = props.data;
  const [ empresa, setEmpresa ] = useState(null);
  const [ conta, setConta ] = useState("");
  const [ mes, setMes ] = useState("1");
  const [ ano, setAno ] = useState("2018");
  const [ ativa, setAtiva ] = useState(false);
  const [ expand, setExpand ] = useState([]);
  const headerProps = {
    empresa, setEmpresa, mes, setMes, ano, setAno, ativa, setAtiva,
    expand, setExpand
  }
  return (
    <>
      <Header {...headerProps} empresas={empresas} />
      { empresa && ativa &&
        <div style={{
          display: "flex",
        }}>
          <Content
            empresa={empresa}
            mes={mes}
            ano={ano}
            // params={{ cod_cta: codCta }}
            expand={expand} 
            setExpand={setExpand}
            setConta={setConta}
          />
        </div>
      }
      <Dialog
        open={Boolean(conta)}
        onClose={()=>setConta(null)}
        scroll="body"
        fullWidth
        maxWidth="md"
      >
        <Lancamentos
          conta={conta}
          empresaId={empresa && empresa.value} 
          mes={mes}
          ano={ano}
        />
      </Dialog>
    </>
  )
}
